mutation updateOnboardingCompanyDetails($input: UpdateOnboardingCompanyDetails!) {
  updateOnboardingCompanyDetails(input: $input) {
    id
    name
    commission
    brokerageName
    licenseNumber
    licenseStatus
    brokerageNameSameAsName
    hasNoInitialWebsite
    address {
      street
      zip
      city
      country
      state
    }
    links {
      website
      imprint
      about
      privacy
    }
  }
}
